


const ciqualCategoriesReducer = (state = {}, action) => {
    switch (action.type) {
      case "FETCH_CIQUAL_CATEGORIES": {
        return {
          ...state,
          ciqual_categories: action.payload,
        };
      }
      default:
        return state;
    }
  };
  
  export default ciqualCategoriesReducer;